export const DS_COLOR_FEEDBACK_WARNING_ICON = "#D47B00";
